export default __webpack_public_path__ + "static/media/kidNft.5ed3c9b0.jpg";